import { useEffect, useState } from 'react';
import { benefitsApi } from '../../../api/benefits.js';

const EVENT_TYPES = ['marriage', 'birth', 'adoption', 'divorce', 'loss_of_coverage', 'address'];
const fmtDate = (v) => (v ? String(v).slice(0, 10) : '—');

export default function LifeEvents() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState(null);

  function refresh() {
    setLoading(true);
    benefitsApi.listLifeEvents()
      .then((d) => setItems(d?.items || []))
      .catch((e) => setError(e.response?.data?.message || 'Failed to load'))
      .finally(() => setLoading(false));
  }
  useEffect(refresh, []);

  async function submit(e) {
    e.preventDefault();
    // Capture the form node before any await: React nulls `e.currentTarget`
    // once the event handler returns, so reading it post-await throws.
    const form = e.currentTarget;
    const fd = new FormData(form);
    try {
      await benefitsApi.createLifeEvent({
        employee_id: fd.get('employee_id'),
        type: fd.get('type'),
        event_date: fd.get('event_date'),
        window_days: fd.get('window_days') ? Number(fd.get('window_days')) : 30,
      });
      form.reset();
      setShowForm(false);
      refresh();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to submit');
    }
  }

  async function approve(id) {
    try {
      await benefitsApi.approveLifeEvent(id);
      refresh();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to approve');
    }
  }

  async function reject(id) {
    try {
      await benefitsApi.rejectLifeEvent(id);
      refresh();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to reject');
    }
  }

  return (
    <section data-testid="benefits-lifeevents-page" data-loading={loading ? 'true' : 'false'}>
      <header className="page-header">
        <div>
          <h1>Life Events</h1>
          <p className="muted">{items.length} events</p>
        </div>
        <button className="btn primary" data-testid="benefits-lifeevent-new" onClick={() => setShowForm((s) => !s)}>
          {showForm ? 'Close' : '+ Submit Life Event'}
        </button>
      </header>

      {error && <div className="alert error" data-testid="benefits-lifeevents-error">{error}</div>}

      {showForm && (
        <form onSubmit={submit} className="card form-card grid-form">
          <label>Employee ID<input name="employee_id" data-testid="benefits-le-empid-input" required /></label>
          <label>Event Type
            <select name="type" data-testid="benefits-le-type-input" defaultValue="marriage">
              {EVENT_TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
            </select>
          </label>
          <label>Event Date<input name="event_date" type="date" data-testid="benefits-le-date-input" required /></label>
          <label>Enrollment Window (days)<input name="window_days" type="number" min="1" max="365" defaultValue="30" data-testid="benefits-le-days-input" /></label>
          <div className="full actions">
            <button className="btn primary" type="submit" data-testid="benefits-lifeevent-submit">Submit</button>
          </div>
        </form>
      )}

      <div className="card">
        <table className="data-table" data-testid="benefits-lifeevent-list">
          <thead>
            <tr><th>Employee</th><th>Type</th><th>Event Date</th><th>Window</th><th>Status</th><th></th></tr>
          </thead>
          <tbody>
            {items.map((le) => (
              <tr key={le.id} data-testid={`benefits-le-row-${le.id}`}>
                <td>{le.employee_id}</td>
                <td>{le.type}</td>
                <td>{fmtDate(le.event_date)}</td>
                <td>{fmtDate(le.window_opens_at)} → {fmtDate(le.window_closes_at)}</td>
                <td>
                  <span className={`chip status-${le.status}`} data-testid={`benefits-le-status-${le.id}`}>
                    {le.status}
                  </span>
                </td>
                <td className="actions-cell">
                  {le.status === 'pending' && (
                    <>
                      <button className="btn small" data-testid={`benefits-le-approve-${le.id}`} onClick={() => approve(le.id)}>Approve</button>
                      <button className="btn small danger" data-testid={`benefits-le-reject-${le.id}`} onClick={() => reject(le.id)}>Reject</button>
                    </>
                  )}
                </td>
              </tr>
            ))}
            {!loading && items.length === 0 && (
              <tr><td colSpan={6} className="muted">No life events submitted.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}
